export default {"src":"/_next/static/media/not-found-illustration.2b9e041a.svg","height":290,"width":280,"blurWidth":0,"blurHeight":0};